import Features from "./components/Features";
import Footer from "./components/Footer";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import MyInsurance from "./components/MyInsurance";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";

const Home = () => {
    return(
        <>
            <Header />
            <HeroSection />
            <Features/>
            <Pricing/>
            {/* <MyInsurance/> */}
            <Testimonials/>
            <Footer />
        </>
    )
}

export default Home;